import React, { useState, useEffect } from "react";
import { Dialog, IconButton, Typography, withStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import AssociationForm from "../AssociationForm";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ViewAssociationDialog = (props) => {
  const {
    classes,
    isDialogOpen,
    selectedRecordName,
    selectedAssociations,
    allowedAssociations = [],
    existingAssociations = [],
    canRemoveAssociation,
    onClose,
    onSubmit,
  } = props;
  const { t } = useTranslation();

  const [noAassociationError, setNoAassociationError] = useState(false);
  const [associations, setAssociations] = useState([]);
  const [targetEntity, setTargetEntity] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [hasAttributeError, setHasAttributeError] = useState(false);

  useEffect(() => {
    setShowForm(false);
    if (selectedAssociations) {
      const { associations = [], entity = {} } = selectedAssociations;
      const tas = JSON.parse(JSON.stringify(associations));
      setAssociations(tas);
      setTargetEntity(entity);
    }
    setShowForm(true);
  }, [selectedAssociations]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const submit = async () => {
    if (hasAttributeError) {
      return;
    }
    if (associations.length === 0) {
      setNoAassociationError(true);
    } else {
      setNoAassociationError(false);
      setSubmiting(true);
      const updatedAssociations = associations.map((as) => {
        const { associationId, attributes } = as;
        return {
          id: associationId,
          attributes: attributes.map((attr) => {
            return {
              id: attr.id,
              dataType: attr.data_type,
              value: attr.user_value,
            };
          }),
        };
      });
      await onSubmit(updatedAssociations);
      setSubmiting(false);
    }
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose}
      aria-labelledby="add-document-modal"
      open={isDialogOpen}
      fullWidth={true}
      maxWidth="xl"
      scroll={"paper"}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="add-document-modal" onClose={handleClose}>
        <Typography className={classes.panelTitle}>
          {t("labels.record.associations.associationsWith", {
            recordName: selectedRecordName,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {showForm && (
          <AssociationForm
            isEditing={true}
            targetEntityId={targetEntity.id}
            associations={associations}
            allowedAssociations={allowedAssociations}
            noAassociationError={noAassociationError}
            canRemoveAssociation={canRemoveAssociation}
            existingAssociations={existingAssociations}
            setHasAttributeError={setHasAttributeError}
          />
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton 
          variant="secondary" 
          onClick={handleClose}
        >
          {t("labels.common.cancel")}
        </CustomButton>
        <CustomButton 
          variant="primary" 
          isLoading={submiting}
          onClick={submit}
        >
          {t("labels.common.save")}
        </CustomButton>
        
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(ViewAssociationDialog);
